import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const login = (data) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('is_authenticated', 'true');
        localStorage.setItem('role', data.is_admin ? 'admin' : 'user');
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.setItem('is_authenticated', 'false');
        localStorage.removeItem('role');
    };

    return (
        <AuthContext.Provider value={{ login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
